
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var calendarInline = self.$app.calendar.create({
      containerEl: '#calendar-inline-container',
      value: [],
      weekHeader: true,
      dateFormat: "yyyy-mm-dd",
      renderToolbar: function () {
        return '<div class="toolbar calendar-custom-toolbar no-shadow">' + '<div class="toolbar-inner">' + //                            '<div class="left">' +
        //                            '<a href="#" class="link icon-only"><i class="icon icon-back ' + (self.$app.theme === 'md' ? 'color-black' : '') + '"></i></a>' +
        //                            '</div>' +
        '<div class="center"></div>' + '<div class="preloader calendar-preloader color-blue"></div>' + //                            '<div class="right">' +
        //                            '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (self.$app.theme === 'md' ? 'color-black' : '') + '"></i></a>' +
        //                            '</div>' +
        '</div>' + '</div>';
      },
      on: {
        init: function (c) {
          $$('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear); //                        $$('.calendar-custom-toolbar .left .link').on('click', function () {
          //                            calendarInline.prevMonth();
          //                        });
          //                        $$('.calendar-custom-toolbar .right .link').on('click', function () {
          //                            calendarInline.nextMonth();
          //                        });

          self.loadServices(c, c.currentYear, c.currentMonth);
        },
        monthYearChangeStart: function (c) {
          $$('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear); //self.loadServices(c, c.currentYear, c.currentMonth + 1);
        },
        //                    dayClick: function (calendar, dayEl, year, month, day) {
        //                        console.log(calendar, dayEl, year, month, day);
        //                        self.loadDayServices(calendar, year + "-" + (month + 1) + "-" + day);
        //                    },
        change: function (calendar, value) {
          //console.log("<><><><><><>", value);
          if (value.length > 0) {
            self.loadDayServices(calendar, value[0].getFullYear().toString() + "-" + (value[0].getMonth() + 1).toString() + "-" + value[0].getDate().toString());
          }
        }
      },
      events: []
    });
  },
  data: function () {
    return {
      events: {},
      services: null
    };
  },
  methods: {
    openServiceDetails: function (id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var service = null;
      self.services.forEach(function (srvc) {
        if (srvc.id == id) {
          service = srvc;
          return false;
        }
      });
      var router = self.$router;
      router.navigate("/request-details/", {
        context: {
          request: service,
          backButton: "Back"
        }
      });
    },
    loadDayServices: function (calendar, date) {
      //console.log("loadDayServices:", date);
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("repair/ondate"),
        preloader: false,
        progress: true,
        beforeSend: function () {
          self.$setState({
            services: null
          });
          $$(".calendar-preloader").removeClass("display-none");
        },
        complete: function () {
          $$(".calendar-preloader").addClass("display-none");
        },
        data: {
          date: date
        },
        success: function (data, status, xhr) {
          //console.log(data);
          self.$setState({
            services: data
          });
        }
      });
    },
    loadServices: function (calendar, year, month) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var lastDay = new Date(year, month, 0);
      var from = new Date(year, month - 2, 1);
      var to = new Date(year, month + 3, 0);
      var fromMonth = from.getMonth() + 1;
      var toMonth = to.getMonth() + 1; //console.log(from, to, fromMonth, toMonth);

      app.request({
        url: Url.to("repair/history"),
        preloader: false,
        progress: true,
        beforeSend: function () {
          $$(".calendar-preloader").removeClass("display-none");
        },
        complete: function () {
          $$(".calendar-preloader").addClass("display-none");
        },
        data: {
          from: from.getFullYear() + "-" + (fromMonth < 10 ? "0" + fromMonth : fromMonth) + "-01",
          to: to.getFullYear() + "-" + (toMonth < 10 ? "0" + toMonth : toMonth) + "-" + to.getDate()
        },
        success: function (data, status, xhr) {
          var events = self.events;
          data.forEach(function (value) {
            //console.log(value);
            var d = value.scheduled_at.split(" ")[0].split("-");
            var date = new Date(d[0], d[1] == 0 ? 12 : d[1] - 1, d[2]);
            events[value.id] = {
              date: date,
              color: '#378cff'
            };
          });
          calendar.params.events = Object.values(events);
          calendar.params.minDate = from;
          calendar.params.maxDate = to;
          calendar.setValue([new Date()]);
          self.$setState({
            events: events
          }, function () {
            calendar.update();
          });
        }
      });
    }
  },
  id: '2645676e0a',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="history">\n        <!-- Top Navbar -->\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">My Mitsu</span>\n                    </a>\n                </div>\n                <div class="title sliding">History</div>\n                <div class="right"></div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="block block-strong no-padding no-margin-bottom">\n                <div id="calendar-inline-container"></div>\n            </div>\n\n\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.services, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="list no-margin">\n                <ul>\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.services, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li>\n                        <a href="#" class="item-link item-content" @click="openServiceDetails(';
              r += c(ctx_3.id, ctx_3);
              r += ')">\n                            <div class="item-inner" style="padding-bottom: 12px;padding-top: 12px;">\n                                <div class="item-title">\n                                    <div class="item-header">';
              r += c(ctx_3.type_label, ctx_3);
              r += '</div>\n                                    Repair service #';
              r += c(ctx_3.id, ctx_3);
              r += '\n                                    <div class="item-footer">';
              r += c(ctx_3.location, ctx_3);
              r += '</div>\n                                    <div class="item-footer">';
              r += c(ctx_3.equipment, ctx_3);
              r += '</div>\n                                    <div class="item-footer">';
              r += c(ctx_3.problem, ctx_3);
              r += '</div>\n                                </div>\n                                <div class="item-after">View</div>\n                            </div>\n                        </a>\n                    </li>\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li>\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">No service in selected date</div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                </ul>\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="preloader infinite-scroll-preloader"></div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    